import { Component, Prop, h } from '@stencil/core';
import Icon from '../svg/circle-exclamation.svg'
@Component({
  tag: 'cr-icon-circle-exclamation',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconCircleExclamation {
  /**
    * The size of the icon - can be 'small', 'medium' or 'large'
    */
  @Prop() size: string
  @Prop() disabled: boolean
  render() {
    return (
      <div
        part='cr-icon'
        class={`${this.size} ${this.disabled ? 'disabled' : ''}`}
        innerHTML={Icon}
      />
    );
  }

}
